import { useFormikContext } from "formik";
import get from "lodash/get";
import { rgba } from "polished";
import React from "react";
import { useParams, withRouter } from "react-router-dom";
import styled from "styled-components/macro";
import { rem } from "polished";
import { ReactComponent as OkIcon } from "../../../assets/icons/PostcodeOk.svg";

import media from "../../../theme/media";

import ExitContent from "../../../components/ExitContent";
import LoadingIndicator from "../../../components/LoadingIndicator";

import ApplicationContext from "../../../reducers/applicationFrame";
import { FlatApplciationType } from "../../../types";
import Cookies from "js-cookie";

const Complete = () => {
  const {
    state: { schema },
  } = React.useContext(ApplicationContext);
  const { values, setFieldValue } = useFormikContext<FlatApplciationType>();
  const { id } = useParams<{ id: string }>();
  const [saving, setSaving] = React.useState(true);

  // on mount
  React.useEffect(() => {
    if (
      get(values, "resp_armed") === "yes" ||
      get(values, "appl_pregnant_baby") === "yes" ||
      get(values, "appl_det_addr_secret") === "yes" ||
      get(values, "resp_sep_inf") === "yes" ||
      get(values, "prp_witness") === "yes" ||
      get(values, "incident_pys_prev") === "yes" ||
      get(values, "incident_pys_recent") === "yes" ||
      get(values, "incident_fsw_prev") === "yes" ||
      get(values, "incident_fsw_recent") === "yes" ||
      get(values, "incident_htc_prev") === "yes" ||
      get(values, "incident_htc_recent") === "yes" ||
      get(values, "incident_sty_prev") === "yes" ||
      get(values, "incident_sty_recent") === "yes" ||
      get(values, "incident_prev_fv") === "yes" ||
      get(values, "incident_prev_freq") === "yes" ||
      get(values, "pio_bio") === "yes" ||
      get(values, "resp_addiction") === "yes" ||
      get(values, "resp_suicidal") === "yes"
    ) {
      setFieldValue("Flags.high_risk", true);
    } else {
      setFieldValue("Flags.high_risk", false);
    }

    if (get(values, "resp_imm_pro") === "yes") {
      setFieldValue("Flags.interim_sought", true);
    } else {
      setFieldValue("Flags.interim_sought", false);
    }

    setFieldValue("Status", "submitted");

    // eslint-disable-next-line
  }, [schema]);

  // turn off loading screen when <AutoSaver is a reported a confirmed submit
  const form_is_submitted = values.form_is_submitted;
  React.useEffect(() => {
    if (form_is_submitted === "yes") {
      setSaving(false);
      Cookies.remove('anonymousIdenttiyId')
    }
  }, [form_is_submitted]);

  if (saving) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <Inner>
        <Main>
          <SuccessBox>
            <OkIcon />
            <div>
              <h2>
                Your application has been submitted but you do not have an
                intervention order at this stage.
              </h2>
              <p>
                Your reference number is {id}. You will not need to quote this
                number when talking to staff, however it may be useful as a
                reference so keep it somewhere safe.
              </p>
            </div>
          </SuccessBox>{" "}
          <h2>What happens next?</h2>
          <ExitContent />
        </Main>{" "}
      </Inner>{" "}
    </>
  );
};

export default withRouter(Complete);

const Inner = styled.div`
  width: 100%;
  max-width: 1310px;
  position: relative;
  z-index: 1;
  padding: 0;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 2rem;
  ${media.greaterThan("tablet")`
    flex-direction: row;
  `}
`;

const Main = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 646px;
`;

const SuccessBox = styled.div`
  padding: 20px 15px;
  background: ${rgba(`#1ba4b2`, 0.15)};
  width: 100%;
  font-size: ${rem(18)};
  line-height: 1.44;
  position: relative;
  margin-bottom: 40px;

  ${media.greaterThan("tablet")`
    padding: 33px 64px;
  `}

  h2 {
    font-size: 22px;
    margin-top: 0;
  }

  > svg {
    height: 25px;
    width: 25px;
    margin-bottom: 5px;
    ${media.greaterThan("tablet")`
        position: absolute;
        top: 33px;
        left: 32px;
        transform: translateX(-50%);

    `};
  }
`;
